import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const AuthBackToHome: React.FC = () => {
  return (
    <header className="auth-back-home">
      <Link
        to="/"
        className="auth-back-home__link"
        data-testid="auth-back-to-home-link"
      >
        <FiArrowLeft aria-hidden="true" />
        Back to Home
      </Link>
    </header>
  );
};

export default AuthBackToHome;
